import classNames from 'classnames';
import {Image} from '@shopify/hydrogen';

interface SocialMediaCircleProps {
  icon: string;
  href: string;
  platform: string;
}

export const SocialMediaCircle = ({
  icon,
  href,
  platform,
}: SocialMediaCircleProps) => {
  return (
    <a
      href={href}
      className={classNames(
        'rounded-full',
        'bg-white',
        'border-black',
        'border-2',
        'transition',

        'min-w-[29px]',
        'md:min-w-[50px]',

        'flex',
        'items-center',
        'justify-center',

        'px-3',
        'py-3',
        'text-sm',
        'shadow-3px',
        'hover:shadow-none',
        'hover:translate-x-[-3px]',
        'hover:translate-y-[3px]',
      )}
    >
      <Image
        src={icon}
        alt={platform}
        width={18}
        height={18}
        className={classNames('h-3', 'w-3', 'md:h-auto', 'md:w-auto')}
      />
    </a>
  );
};
